import useSWR from 'swr';

import { getSignupByEmail } from '@/api/signups';
import { ENDPOINTS } from '@/api/endpoints';

type GetSignupByEmailResponse = Awaited<ReturnType<typeof getSignupByEmail>>;

export const useGetSignupByEmail = (userEmail: string | undefined) => {
  const { data, error, isLoading, mutate } = useSWR<GetSignupByEmailResponse, Error>(
    userEmail ? [ENDPOINTS.SIGNUP_BY_EMAIL, userEmail] : null,
    ([, email]) => getSignupByEmail(email as string),
    { errorRetryCount: 1, revalidateOnFocus: false }
  );

  return {
    error,
    signup: data,
    loading: isLoading,
    refetch: mutate,
  };
};
